import React from 'react';
import styled from 'styled-components';

const StyledTooltip = styled.div`
  font-size: 14px;
  line-height: 1.5rem;
`;

export const TooLongIterationTooltip = () => {
  return (
    <StyledTooltip>
      Iterations cannot be longer than 90 days. <br />
      Please select a different iteration or a custom range.
    </StyledTooltip>
  );
};
